// @ts-check
import { theme as baseTheme } from '@bottlebooks/gatsby-design-system';
import button from '../components/Button/buttonVariants';
import link from '../components/Link/linkVariants';

const theme = {
  ...baseTheme,
  fontUrls: [
    'https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;700&family=Source+Sans+Pro:ital,wght@0,200;0,400;0,600;1,300&display=swap',
  ],

  sizes: {
    ...baseTheme.sizes,
    container: {
      ...baseTheme.sizes?.container,
      // Restrict the max-size of the container to 960 for now.
      large: 960,
      fluid: 1170,
    },
  },

  styles: {
    // baseTheme.styles.root is applied to the body element automatically by theme-ui 0.3.x+.
    root: {
      padding: 0,
      margin: 0,
      backgroundColor: 'background',
      color: 'text',
      MozOsxFontSmoothing: 'auto',
      WebkitFontSmoothing: 'antialiased',
    },
  },

  button,

  link,
};

export default theme;
